import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/freezeLifecycleSagas";

const UpdateButtons = () => {
  const dispatch = useDispatch();
  const filtersDirty = useSelector((state) => state.freezeLifecycle.filtersDirty);

  return (
    filtersDirty && (
      <>
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>

        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      </>
    )
  );
};

export default UpdateButtons;
